import React from 'react';
import AirlineRow from './airline-row';

const FilterVisaOnArrival = ({ filterType, showCountries, showCountriesFilter, updateFilter }) => {
  return (
    <>
      {showCountries && showCountries.length > 0 ? (
        <div className="flexCol">
          <div className="padB10 flexCol">
            <div className="dF justifyBetween quicksand">
              <div className="black fb font14 quicksand">Show countries that</div>
            </div>
            <div className="grey font11 padT5"></div>
          </div>
          <div className="flexCol">
            {showCountries.map((location, index) => {
              return (
                <AirlineRow
                  updateFilter={updateFilter}
                  location={location}
                  index={index}
                  filterType={filterType}
                  isChecked={showCountriesFilter.includes(location)}
                />
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
};
export default FilterVisaOnArrival;
